import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PaymentCallback() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refreshUser } = useAuth();
  const [status, setStatus] = useState("verifying");
  const reference = params.get("reference") || params.get("trxref");

  useEffect(() => {
    if (!reference) { setStatus("failed"); return; }
    api.get(`/subscription/verify/${reference}`)
      .then(async ({ data }) => {
        if (data.status === "success") {
          await refreshUser();
          setStatus("success");
          setTimeout(() => nav("/"), 1800);
        } else setStatus("failed");
      })
      .catch(() => setStatus("failed"));
  }, [reference]);

  return (
    <div className="min-h-screen grid place-items-center px-4" data-testid="payment-callback-page">
      <div className="text-center bg-card border border-white/10 rounded-2xl p-10 max-w-sm">
        {status === "verifying" && (<><Loader2 className="animate-spin text-brand mx-auto mb-4" size={44} /><p className="font-semibold">Verifying your payment…</p></>)}
        {status === "success" && (<><CheckCircle2 className="text-green-400 mx-auto mb-4" size={48} /><p className="font-head text-xl font-bold mb-1">Welcome to Premium!</p><p className="text-zinc-400 text-sm">Redirecting you to start watching…</p></>)}
        {status === "failed" && (<><XCircle className="text-brand mx-auto mb-4" size={48} /><p className="font-head text-xl font-bold mb-1">Payment not completed</p><button onClick={() => nav("/subscribe")} className="mt-4 bg-brand px-5 py-2 rounded-lg font-semibold">Try again</button></>)}
      </div>
    </div>
  );
}
